import { useState } from "react";
import { useGetCouponGroupDetails, useGetCouponGroups } from "../../services/couponGroup/couponGroup.service";
import { useFetchErrorToast } from "../../utils/useFetchErrorToasts/useFetchErrorToast";
import { CouponGroup, CouponGroupDetail } from "../../services/couponGroup/couponGroup.types";
import Header from "../../common/Header/Header";
import {
  Buttons, Page, TableWrapper
} from "../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles";
import Table from "../../components/Table/Table";
import { readOnlyLabelTableText } from "../../constants/GlobalTexts";
import Button from "../../components/Button/Button";
import { Variant } from "../../components/Button/Button.types";
import { CSVLink } from "react-csv";

const CouponGroups = () => {
  const { data: getCouponGroupsResponse, isError: getCouponGroupsIsError } = useGetCouponGroups();
  const couponGroups: CouponGroup[] = getCouponGroupsResponse?.data ?? [];
  useFetchErrorToast([
    {
      isError: getCouponGroupsIsError,
      label: 'Error fetching Coupon Groups',
      id: 'couponGroupsFetchError'
    }
  ])

  const [selectedCouponGroup, setSelectedCouponGroup] = useState<CouponGroup | undefined>(undefined)

  const { data: getCouponGroupDetailsResponse, isError: getCouponGroupDetailsIsError } =
      useGetCouponGroupDetails(selectedCouponGroup?.couponGroupId ?? '', !!selectedCouponGroup);
  const couponGroupDetails: CouponGroupDetail[] = getCouponGroupDetailsResponse?.data ?? [];
  useFetchErrorToast([
    {
      isError: getCouponGroupDetailsIsError,
      label: 'Error fetching Coupon Group Details',
      id: 'couponGroupDetailsFetchError'
    }
  ])

  return (
      <>
        <Header
            breadcrumb={{ to: '/tables', label: 'All tables' }}
            title="Coupon Groups"
            titleTestId={'CouponGroupsPageTitle'}
        />
        <Page style={{ gap: '1rem' }}>
          <TableWrapper>
            <Table
                rowData={couponGroups}
                returnedRecords={couponGroups.length}
                height={'100%'}
                readOnlyLabel={readOnlyLabelTableText}
                onSelectionChanged={event => setSelectedCouponGroup(event.api.getSelectedRows()?.[0])}
                columnDefs={[
                  {
                    width: 30,
                    field: '',
                    headerName: '',
                    checkboxSelection: true,
                    floatingFilter: false,
                    sortable: false
                  },
                  { flex: 1, field: 'couponGroupId', headerName: 'Coupon Group' },
                  { flex: 1, field: 'description', headerName: 'Description' }
                ]}
            />
          </TableWrapper>
          <TableWrapper>
            <Table
                headerTitle={'Assigned Coupons'}
                rowData={couponGroupDetails}
                returnedRecords={couponGroupDetails.length}
                height={'100%'}
                readOnlyLabel={readOnlyLabelTableText}
                columnDefs={[
                  { flex: 1, field: 'couponId', headerName: 'Coupon' }
                ]}
            />
          </TableWrapper>
          <Buttons style={{ padding: 0 }}>
            <CSVLink
                data={couponGroupDetails}
                filename={`CouponGroupDetails_${new Date().toISOString().split('T')[0]}.csv`}
                style={{ textDecoration: 'none', color: 'inherit' }}
                headers={[
                  { key: 'couponGroupId', label: 'Coupon Group' },
                  { key: 'couponId', label: 'Coupon' }
                ]}
            >
              <Button variant={Variant.Secondary} label="Export to CSV"/>
            </CSVLink>
          </Buttons>
        </Page>
      </>
  )
}

export default CouponGroups;